import { useTranslation } from "lib/i18n/translation"
import { Tooltip } from "components/tooltip"

export const FilmVersion = ({ filmVersion }) => {
	const { c } = useTranslation("common")

	return (
		<li>
			<span className={filmVersion.name}>{c(filmVersion.name)} </span>
			<a
				href="#"
				onClick={e => e.preventDefault()}
				rel="nofollow noopener"
				title={filmVersion.tooltipValue}
				className="tooltip-toggle"
				aria-describedby={`tooltip-${filmVersion.name}`}
			>
				{filmVersion.value}
			</a>
			<Tooltip
				id={`tooltip-${filmVersion.name}`}
				style={{ width: 160 }}
			>
				<span><strong>{c(filmVersion.name)}</strong><br />{filmVersion.tooltipValue}</span>
			</Tooltip>
		</li>
	)
}
